/** FTO Pro 可阅读报告的首次任务奖励接入 service。 */
export interface FtoProReportOnboardingService {
    /** 初始化当前 FTO 页面作用域内的奖励能力。 */
    initialize(): Promise<void>;
    /** 通知 service 当前报告已经生成成功并可供阅读。 */
    notifyReportAvailable(reportId: string): void;
    /** 仅在本地开发环境强制启动权益卡片，供视觉调试入口使用。 */
    debugStart(reportId: string): void;
    /** 清理领取上下文和权益卡片。 */
    destroy(): void;
}

/** FTO Pro 报告 onboarding service 的容器标识。 */
export const FtoProReportOnboardingService = Symbol('FtoProReportOnboardingService');
